import React from 'react';
import { ToastContainer } from 'react-toastify';
import Navbar from '../components/PartnerPage/Navbar';
import HeroSection from '../components/PartnerPage/HeroSection';
import BenefitsSection from '../components/PartnerPage/BenefitsSection';
import SpecialOfferDescription from '../components/PartnerPage/SpecialOfferDescription';
import Footer from '../components/PartnerPage/Footer';
import OurServiceSection from '../components/PartnerPage/OurServiceSection';
import { EmailInputProvider } from '../contexts/EmailInputContext';
import HelpIcon from 'images/help-icon.png';
import ShipPlayClearLogo from 'images/ship-play-clear-logo.png';
import NavLogo from 'images/ship-play-nav-logo.png';
import BenefitsVisual from 'images/bike-ampersand.png';

export default function ClearPartnerPage() {
  const benefits = [
    {
      icon: 'truck-icon',
      title: 'No Baggage, No Boundaries',
      description: 'Skip the hassle of carrying and checking bags.',
    },
    {
      icon: 'globe-icon',
      title: 'Door-to-Door Convenience',
      description: 'We pick up and deliver your luggage directly.',
    },
    {
      icon: 'suitcase-icon',
      title: 'Travel with Confidence',
      description: 'Every shipment is trackable and fully insured.',
    },
  ];

  return (
    <>
      <EmailInputProvider>
        <ToastContainer />
        {/* Background image container with responsive height */}
        <div className="relative font-poppins bg-cover bg-center backgroundImage">
          <Navbar NavLogo={NavLogo} logoClasses="w-60 sm:w-64 md:w-80 lg:w-auto max-w-80" showExtraLinks={true} />
          <HeroSection
            heading={
              <>
                Stress less with CLEAR Plus <br/>and
                <span className="text-[#5CFF85]">
                  &nbsp;Ship&Play
                </span>
              </>
            }
            subheading={
              <>
                Ship your luggage and <b>get 50% off your first shipment!</b>
                <br />Enter your email below to claim your discount code, exclusive for CLEAR Plus Members.
              </>
            }
          />
        </div>

        <main className="flex flex-col items-center justify-between w-full font-poppins">
          <OurServiceSection />
          <BenefitsSection title="Ship & Play benefits" benefits={benefits} src={BenefitsVisual} />
          <SpecialOfferDescription />
        </main>
      </EmailInputProvider>
      <Footer FooterLogo={ShipPlayClearLogo} brand="shipplay" shipLinkPath="/pricing">
        {/* Privacy Statement */}
        <div className="
          flex flex-col gap-4 lg:gap-0 lg:flex-row items-center
          justify-center sm:space-x-4 text-center pb-9
        ">
          <img
            src={HelpIcon}
            alt="Life Vest Icon"
            className="h-20 w-20"
          />
          <p className="mb-2 text-xl font-semibold sm:pl-3 pt-2">
            Your information is safe with us. We respect your privacy and protect your data.
          </p>
        </div>

        {/* Contact Section */}
        <div className="text-left py-8 border-t border-[#FFF] border-opacity-20 pl-[5%] lg:pl-0">
          <h5 className="text-white text-xl font-semibold mb-2">Have questions?</h5>
          <p className="mb-2 text-lg leading-8">
            Our friendly support team is here to help! Contact us at&nbsp;
            <a
              href="mailto:customersupport@shipplay.com"
              className="text-[#49C44F] hover:text-[#6ad687] underline break-words"
            >
              customersupport@shipplay.com
            </a>
            &nbsp;or call&nbsp;
            <a className="text-[#49C44F] hover:text-[#6ad687] underline" href="tel:8557927529">(855) 792-7529</a>.
          </p>
        </div>
      </Footer>
    </>
  );
}
